import { Trip_Cluster_v2 } from '../util/tripPlanner_types';
import { titleCase_withStates } from '../util/general_util';

export function init_rvRental_display(stop:Trip_Cluster_v2) {

    $("#rentRV_stopName").html(titleCase_withStates(stop.clusterTitle));
	$("#searchRVrentals").attr("loc",JSON.stringify(stop.coords));

    if (window.rvRental_sDate_pickr !== undefined) {

        window.rvRental_sDate_pickr.config.onChange = []//() => {return false};
        window.rvRental_eDate_pickr.config.onChange = []//() => {return false};

        let initializedDate:boolean = false;
        if (stop.s_date !== undefined && stop.s_date !== null) {
            window.rvRental_sDate_pickr.setDate(stop.s_date);
            initializedDate = true;
        } else if (stop.selectedCamps.length > 0) {
            for (let i:number = stop.selectedCamps.length - 1; i >= 0; i--) {
                if (stop.selectedCamps[i].s_date !== undefined && stop.selectedCamps[i].s_date !== null) {
                    window.rvRental_sDate_pickr.setDate(stop.selectedCamps[i].s_date);
                    window.rvRental_eDate_pickr.clear();
                    initializedDate = true;
                    break;
                };
            };
        };

        if (!initializedDate) {
            window.rvRental_sDate_pickr.clear();
            window.rvRental_eDate_pickr.clear();
        };

        window.rvRental_sDate_pickr.config.onChange.push(function(selectedDates: Array<Date>, dateStr: string, instance: any) {
            $("form#searchRVrentals").trigger("submit");
        });
        window.rvRental_eDate_pickr.config.onChange.push(function(selectedDates: Array<Date>, dateStr: string, instance: any) {
            $("form#searchRVrentals").trigger("submit");
        });
    };
};